import { render, staticRenderFns } from "./TableOrderLink.vue?vue&type=template&id=4edd0c12"
import script from "./TableOrderLink.vue?vue&type=script&lang=js"
export * from "./TableOrderLink.vue?vue&type=script&lang=js"
import style0 from "./TableOrderLink.vue?vue&type=style&index=0&id=4edd0c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports